"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var _ = require("lodash");
var ui_1 = require("@vidazoo/ui");
var utils_1 = require("@vidazoo/ui/lib/components/utils");
/**
 * @export
 * @class BaseListStore
 * @implements {IBaseListStore<T, U, N>}
 * @template T - ListItem interface type
 * @template U - User interface type
 * @template N - Network interface type
 */
var BaseListStore = /** @class */ (function () {
    function BaseListStore(notificationsStore, searchList, itemType, sort) {
        if (searchList === void 0) { searchList = []; }
        if (sort === void 0) { sort = "name"; }
        var _this = this;
        this.notificationsStore = notificationsStore;
        this.searchList = searchList;
        this.itemType = itemType;
        this.bulkActionHandlers = {
            delete: function () { return _this.deleteSelectedValues(); },
            activate: function () { return _this.setActiveSelectedValues(true); },
            deactivate: function () { return _this.setActiveSelectedValues(false); },
            archive: function () { return _this.setArchiveSelectedValues(true); },
            unarchive: function () { return _this.setArchiveSelectedValues(false); }
        };
        this.setPromptDeleteItem = function (item) {
            _this.promptDeleteItem = item;
        };
        this.setSearchQuery = function (searchKey, value) {
            mobx_1.transaction(function () {
                _this.searchQueries[searchKey] = value;
            });
        };
        this.sort = function (sortBy, preserveDirection) {
            mobx_1.transaction(function () {
                if (sortBy === _this.sortBy && !preserveDirection) {
                    _this.sortDirection = _this.sortDirection === ui_1.SortDirection.ASC ? ui_1.SortDirection.DESC : ui_1.SortDirection.ASC;
                }
                _this.sortBy = sortBy;
                _this.items.replace(_.orderBy(_this.items, [_this.sortBy], [_this.sortDirection.toString()]));
            });
        };
        this.setTableDensity = function (density) {
            _this.density = density;
        };
        this.loadMore = function () {
            if (_this.items.length > _this.page * _this.pageSize) {
                _this.setPage(_this.page + 1);
            }
        };
        this.toggleItem = function (id) {
            if (_.includes(_this.selectedValues, id)) {
                _this.selectedValues = _this.selectedValues.filter(function (x) { return x !== id; });
            }
            else {
                _this.selectedValues = _this.selectedValues.concat(id);
            }
        };
        this.toggleAllItems = function (state) {
            if (_this.allItemsChecked) {
                _this.selectedValues = [];
            }
            else {
                _this.selectedValues = _this.filteredItems.map(function (x) { return x._id; });
            }
        };
        this.applyBulkAction = function (actionName) {
            if (_this.selectedValues.length === 0) {
                return;
            }
            var proc = _this.bulkActionHandlers[actionName];
            if (proc) {
                proc().then(function () {
                    _this.onUpdateStateSuccess();
                    _this.getItems();
                }).catch(function () {
                    _this.onActionError(actionName);
                    _this.getItems();
                });
            }
        };
        this.reset(sort);
    }
    BaseListStore.prototype.reset = function (sort) {
        var _this = this;
        if (sort === void 0) { sort = "name"; }
        mobx_1.transaction(function () {
            _this.items = mobx_1.observable([]);
            _this.isLoading = false;
            _this.count = 0;
            _this.sortBy = sort;
            _this.sortDirection = ui_1.SortDirection.ASC;
            _this.density = ui_1.Density.Medium;
            _this.page = 1;
            _this.pageSize = 50;
            _this.selectedValues = mobx_1.observable([]);
            _this.resetSearchQueries();
        });
    };
    BaseListStore.prototype.onLoadItemsSuccess = function (res) {
        var _this = this;
        mobx_1.transaction(function () {
            _this.isLoading = false;
            _this.items = res.data.results;
            _this.count = res.data.count;
        });
    };
    BaseListStore.prototype.onLoadItemsError = function (res) {
        this.isLoading = false;
        this.notificationsStore.pushErrorNotification({
            title: "Operation Error",
            text: "Failed to fetch " + this.itemType,
            timeout: 5000
        });
    };
    BaseListStore.prototype.onUpdateStateSuccess = function () {
        this.notificationsStore.pushSuccessNotification({
            title: "Operation Complete",
            text: this.itemType + " updated successfully",
            timeout: 5000
        });
    };
    BaseListStore.prototype.onUpdateStateError = function (item) {
        item.isActive = !item.isActive;
        this.notificationsStore.pushErrorNotification({
            title: "Operation Error",
            text: "Failed to update " + this.itemType,
            timeout: 5000
        });
    };
    BaseListStore.prototype.onDeleteItemSuccess = function (id) {
        this.items.replace(this.items.filter(function (item) { return item._id !== id; }));
        this.promptDeleteItem = null;
        this.notificationsStore.pushSuccessNotification({
            title: "Operation Complete",
            text: this.itemType + " deleted successfully",
            timeout: 5000
        });
    };
    BaseListStore.prototype.onDeleteItemError = function () {
        this.promptDeleteItem = null;
        this.notificationsStore.pushErrorNotification({
            title: "Operation Error",
            text: "Failed to delete " + this.itemType,
            timeout: 5000
        });
    };
    BaseListStore.prototype.resetSearchQueries = function () {
        var _this = this;
        mobx_1.transaction(function () {
            var searchQueries = {};
            _.forEach(_this.searchList, function (field) {
                searchQueries[field] = "";
            });
            _this.searchQueries = searchQueries;
        });
    };
    Object.defineProperty(BaseListStore.prototype, "filteredItems", {
        get: function () {
            var _this = this;
            var hasQueries = _(this.searchQueries).values().compact().value().length > 0;
            if (!hasQueries) {
                return this.items;
            }
            return _.filter(this.items, function (item) {
                var matchQueries = _.map(_this.searchQueries, function (query, field) {
                    // return (item[field] ? item[field].toString() : "").toLowerCase().indexOf(query.toLowerCase()) > -1;
                    // null values will pass the _.get check ¯\_(ツ)_/¯
                    var value = (_.get(item, field, "") || "").toString();
                    return utils_1.multiWordFilter(value, query);
                });
                return _.every(matchQueries);
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseListStore.prototype, "sortDir", {
        get: function () {
            return this.sortDirection === ui_1.SortDirection.ASC ? 1 : -1;
        },
        enumerable: true,
        configurable: true
    });
    BaseListStore.prototype.setPage = function (page) {
        this.page = page;
    };
    BaseListStore.prototype.onActionError = function (actionName) {
        this.notificationsStore.pushErrorNotification({
            title: "Operation Failed",
            text: "Failed to " + actionName + " " + this.selectedValues + " " + this.itemType,
            timeout: 5000
        });
    };
    BaseListStore.prototype.deleteSelectedValues = function () {
        return null;
    };
    BaseListStore.prototype.setActiveSelectedValues = function (state) {
        return null;
    };
    BaseListStore.prototype.setArchiveSelectedValues = function (state) {
        return null;
    };
    Object.defineProperty(BaseListStore.prototype, "allItemsChecked", {
        get: function () {
            return this.filteredItems.length === this.selectedValues.length;
        },
        enumerable: true,
        configurable: true
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], BaseListStore.prototype, "items", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], BaseListStore.prototype, "isLoading", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], BaseListStore.prototype, "count", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], BaseListStore.prototype, "sortBy", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], BaseListStore.prototype, "sortDirection", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], BaseListStore.prototype, "searchQueries", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], BaseListStore.prototype, "density", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], BaseListStore.prototype, "promptDeleteItem", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], BaseListStore.prototype, "page", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], BaseListStore.prototype, "pageSize", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], BaseListStore.prototype, "selectedValues", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseListStore.prototype, "reset", null);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseListStore.prototype, "setPromptDeleteItem", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseListStore.prototype, "onLoadItemsSuccess", null);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseListStore.prototype, "onLoadItemsError", null);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseListStore.prototype, "onUpdateStateSuccess", null);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseListStore.prototype, "onUpdateStateError", null);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseListStore.prototype, "onDeleteItemSuccess", null);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseListStore.prototype, "onDeleteItemError", null);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseListStore.prototype, "setSearchQuery", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseListStore.prototype, "sort", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseListStore.prototype, "setTableDensity", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseListStore.prototype, "resetSearchQueries", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], BaseListStore.prototype, "filteredItems", null);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseListStore.prototype, "loadMore", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseListStore.prototype, "setPage", null);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseListStore.prototype, "toggleItem", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseListStore.prototype, "toggleAllItems", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseListStore.prototype, "applyBulkAction", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseListStore.prototype, "onActionError", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], BaseListStore.prototype, "allItemsChecked", null);
    return BaseListStore;
}());
exports.default = BaseListStore;
